<div class="h-full min-h-0" *transloco="let t">
  <app-form-preview-split class="h-full">
    <div splitMain class="h-full min-h-0 overflow-auto px-8 pt-8">
      <div class="mb-6 flex max-w-75 flex-col gap-1">
        <h4>{{ t("sb-form-assets.title") }}</h4>
        <p class="type-body text-muted-foreground m-0">{{ t("sb-form-assets.description") }}</p>
      </div>

      @if (preModeration.hasLaunched()) {
        @if (preModeration.warning(); as warning) {
          <div class="mb-6 max-w-75">
            <IAlert
              type="warning"
              data-testid="premoderation-warning"
              [title]="t('sb-form-creative.amazon_pre-moderation')"
            >
              <ul class="m-0 list-inside space-y-1 p-0">
                @if (warning.headline) {
                  <li>{{ warning.headline }}</li>
                }
                @if (warning.brandLogo) {
                  <li>{{ warning.brandLogo }}</li>
                }
              </ul>
            </IAlert>
          </div>
        }
      }

      <div class="flex max-w-75 flex-col gap-6">
        @if (showBrandFields()) {
          <IFormField>
            <label iLabel>
              {{ t("sb-form-creative.brand_name") }}
              <span class="text-destructive">{{ assets().brandName().required() ? "*" : "" }}</span>
            </label>
            <input
              iInput
              [formField]="assets().brandName"
              [readOnly]="assets().brandName().readonly()"
              size="sm"
              [placeholder]="t('sb-form-creative.brand_name')"
              class="sensitive-data"
              data-testid="brand-name-input"
            />
            <IError>{{ brandNameErrorMessage() }}</IError>
          </IFormField>

          <IFormField>
            <label iLabel>
              {{ t("sb-form-creative.headline") }}
              <span class="text-destructive">{{ assets().headline().required() ? "*" : "" }}</span>
            </label>
            <input
              iInput
              [formField]="assets().headline"
              size="sm"
              [placeholder]="t('sb-form-creative.headline')"
              data-testid="headline-input"
            />
            @if (showHeadlineMaxLengthHint()) {
              <span iHint>{{ t("sb-form-creative.headline_max_length", [headlineMaxLength()]) }}</span>
            }
            <IError>{{ headlineErrorMessage() }}</IError>
          </IFormField>

          <div class="flex flex-col gap-2">
            <label iLabel>
              {{ isVendor() ? t("sb-form-creative.logo") : t("creative-display.brand_logo") }}
              <span class="text-destructive">{{ assets().brandLogo().required() ? "*" : "" }}</span>
            </label>
            <app-media-input
              class="max-w-full"
              [disabled]="!brandAssetsLoaded()"
              [mediaType]="MediaType.brandLogo"
              [medias]="brandLogos()"
              [savedMedia]="assets().brandLogo().value() ?? undefined"
              [removable]="true"
              (mediaSaved)="selectBrandLogo($event)"
              (mediaDeleted)="selectBrandLogo(null)"
              (toUpload)="onUpload($event, MediaType.brandLogo)"
              testId="brand-logo-input"
            />
            @if (assets().brandLogo().value()?.url; as logoUrl) {
              <div class="border-border mt-2 flex size-48 items-center justify-center rounded-lg border p-2.5">
                <img class="sensitive-data max-h-full max-w-full object-contain" [src]="logoUrl" alt="" />
              </div>
            }
          </div>

          @if (displayEmptyHeadlineBrandLogoHint()) {
            <p class="type-label text-muted-foreground m-0">
              <span class="align-middle"><IIcon name="infoCircle" /></span>
              {{ t("sb-form-assets.empty_headline_brand_logo_hint") }}
            </p>
          }
        }

        @if (showVideo()) {
          <div class="flex flex-col gap-2">
            <label iLabel>
              {{ t("sb-form-creative.video") }}
              <span class="text-destructive">{{ assets().video().required() ? "*" : "" }}</span>
            </label>
            <app-media-input
              class="max-w-full"
              [mediaType]="MediaType.videoAsset"
              [medias]="videos()"
              [savedMedia]="assets().video().value() ?? undefined"
              [resetFile]="resetVideoInput"
              [removable]="true"
              (mediaSaved)="selectVideo($event)"
              (mediaDeleted)="selectVideo(null)"
              (toUpload)="onUpload($event, MediaType.videoAsset)"
              testId="video-input"
            />
          </div>
        }
      </div>
    </div>

    <app-creative-preview-list
      splitPreview
      class="block h-full min-h-0"
      [creativeType]="creativeType()"
      [brandName]="assets().brandName().value()"
      [headline]="assets().headline().value()"
      [brandLogoUrl]="assets().brandLogo().value()?.url"
      [videoUrl]="assets().video().value()?.url"
    />
  </app-form-preview-split>
</div>
